// Utils/exportUtils.js
import * as XLSX from "xlsx";

// 🔹 Flatten nested objects
const flattenObject = (obj, prefix = "") => {
    let res = {};

    for (let key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const value = obj[key];
        const newKey = prefix ? `${prefix}_${key}` : key;

        if (value && typeof value === "object" && !Array.isArray(value)) {
            Object.assign(res, flattenObject(value, newKey));
        } else {
            res[newKey] = value;
        }
    }

    return res;
};

// 🔹 Prepare data
export const prepareExportData = (data = []) => {
    return data.map((item) => flattenObject(item));
};

// 🔹 CSV Export
export const exportToCSV = (data, fileName = "export.csv") => {
    if (!data.length) return;

    const headers = Object.keys(data[0]);

    const csvRows = [
        headers.join(","), // header row
        ...data.map((row) =>
            headers.map((field) => `"${row[field] ?? ""}"`).join(",")
        ),
    ];

    const blob = new Blob([csvRows.join("\n")], {
        type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();

    window.URL.revokeObjectURL(url);
};

// 🔹 Excel Export
export const exportToExcel = (data, fileName = "export.xlsx") => {
    if (!data.length) return;

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Export");

    XLSX.writeFile(workbook, fileName);
};